/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";
import Table from "../table/Table.js";
import {getAll} from "../../../backend/read/GetAll";
import {ACCESS_TOKEN_KEY} from "../../../utilities/Constants";
import {decodeToken} from "../../../utilities/auth/Introspect";

class PrinterList extends React.Component {
    constructor(props) {
        super(props);
        const admin = decodeToken(JSON.parse(sessionStorage.getItem(ACCESS_TOKEN_KEY))).admin;
        this.state = {
            data: [],
            cols: [
                {"name": "Printer Name", "attributeName": "PRINTER_ID", "filter": true, "checkboxFilter": false},
                {"name": "Station Code", "attributeName": "STATION_CODE", "filter": true, "checkboxFilter": false},
                {"name": "Status", "attributeName": "ACTIVE_FLAG", "filter": true, "checkboxFilter": true,
                    "checkboxTitleOne": "ACTIVE", "checkboxTitleTwo": "INACTIVE"},
                {"name": "Last Updated (UTC)", "attributeName": "LAST_UPDATED_TIMESTAMP", "filter": false}
            ],
            button: {"name": "Edit", "hide": !admin, "path": "/edit-printer"},
            defaultSort: {'ACTIVE_FLAG': 'asc', "STATION_CODE": 'asc', 'PRINTER_ID': 'asc'}
        };
    }

    componentDidMount() {
        getAll("PRINTERS").then(r => {
            let temp = [];
            JSON.parse(r.body.data).Items.forEach(element => {
                let tempElement = element;
                tempElement.PRINTER_ID = element.PRINTER_ID;
                tempElement.STATION_CODE = element.STATION_CODE;
                let timestamp = new Date(0);
                timestamp.setUTCMilliseconds(element.LAST_UPDATED_TIMESTAMP);
                tempElement.LAST_UPDATED_TIMESTAMP = timestamp.toLocaleString('en-US', {hour12: false, timeZone: 'UTC'});
                if ( element.ACTIVE_FLAG === true ) {
                    tempElement.ACTIVE_FLAG = "ACTIVE";
                }
                else {
                    tempElement.ACTIVE_FLAG = "INACTIVE";
                }
                temp.push(tempElement)
            });
            this.setState({data: temp})
        })
    }

    render() {
        return (
            <div>
                <div className="list-header">
                    <h2>Manage Printers</h2>
                </div>
                <Table data={this.state.data} cols={this.state.cols} button = {this.state.button}
                       defaultSort={this.state.defaultSort}/>
            </div>
        );
    }
}

export default PrinterList;
